import { QSetQuestionDetails } from '@exam-management/qset-question-details';
import { mappedQSetReviewSubtaskStatus } from '@exam-management/task-management';

import { useQSetReviewSubtask } from '../../providers';
import { getQSetReviewSubtaskReviewQuestionVariant } from '../../utils';

export default function QSetReviewSubtaskReviewQuestionSection() {
  const {
    status,
    roles,
    qSetQuestion: { currentQuestion, currentQuestionNumber },
  } = useQSetReviewSubtask();
  const taskStatus =
    mappedQSetReviewSubtaskStatus[status.code as keyof typeof mappedQSetReviewSubtaskStatus];
  const variant = getQSetReviewSubtaskReviewQuestionVariant(roles, taskStatus);

  if (variant === null || variant === 'HIDDEN' || !currentQuestion) {
    return null;
  }

  return (
    <QSetQuestionDetails
      question={currentQuestion}
      order={currentQuestionNumber}
      // FIXME: Uncomment when #UAT1.5 is done
      // endAdornment={
      //   <Button variant='outlined' href='#' target='_blank' startIcon={<LaunchRoundedIcon />}>
      //     Edit QID
      //   </Button>
      // }
    />
  );
}
